import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  @media screen and ", " {\n    height: ", ";\n    margin: 0;\n    width: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  @media screen and ", " {\n    display: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  @media screen and ", " {\n    ", "\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      &::before {\n        @media screen and ", " {\n          display: none;\n        }\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  @media screen and ", " {\n    padding: 0;\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  @media screen and ", " {\n    border-radius: 50%;\n    height: ", ";\n    width: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  @media screen and ", " {\n    width: auto;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { LinkOrButton } from '@scp/ui-shared/components/buttons/LinkOrButton';
import { Icon } from '@scp/ui-shared/theme/icons';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { withoutProps, withOutsideClick } from '@scp/ui-shared/core/hoc';
import { baselineToPx } from '@scp/ui-shared/theme/utils';
import { Popover } from '@scp/ui-shared/components/popover/Popover';
import { mediaQueryTabletMax } from '@scp/ui-shared/theme/responsive';
import { VisuallyHiddenStyle } from '@scp/ui-shared/theme/resets';
import { E2E } from './constants';
import { buttonWrapperBase, buttonBase, mainButtonBase, actionsWrapperBase, buttonIconBase, arrowIconBase, actionsButtonBase } from './baseStyles';
var ButtonWrapper = styled.div(_templateObject(), buttonWrapperBase, mediaQueryTabletMax);
var ButtonElement = withRippleEffect(LinkOrButton);
var ButtonBase = styled(ButtonElement)(_templateObject2(), buttonBase, mediaQueryTabletMax, function (props) {
  return props.small ? baselineToPx(9) : baselineToPx(15);
}, function (props) {
  return props.small ? baselineToPx(9) : baselineToPx(15);
});
var MainButton = styled(ButtonBase)(_templateObject3(), mainButtonBase, mediaQueryTabletMax, function (props) {
  return props.hasActions && css(_templateObject4(), mediaQueryTabletMax);
});
var ActionsButton = styled(ButtonBase)(_templateObject5(), actionsButtonBase);
var ButtonTitle = styled.span(_templateObject6(), mediaQueryTabletMax, VisuallyHiddenStyle);
var ActionsWrapper = styled(withOutsideClick('div'))(_templateObject7(), actionsWrapperBase, mediaQueryTabletMax);
var ButtonIcon = styled(withoutProps(Icon, ['iconColor', 'small']))(_templateObject8(), buttonIconBase, mediaQueryTabletMax, function (props) {
  return props.small ? baselineToPx(6) : baselineToPx(9);
}, function (props) {
  return props.small ? baselineToPx(6) : baselineToPx(9);
});
var ArrowIcon = styled(withoutProps(Icon, ['isOpen'])).attrs({
  color: 'currentColor',
  name: 'keyboard-arrow-down',
  size: 18
})(_templateObject9(), arrowIconBase);
export var AltButtonResponsive = function AltButtonResponsive(props) {
  var children = props.children,
      iconName = props.iconName,
      iconColor = props.iconColor,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$appearance = props.appearance,
      appearance = _props$appearance === void 0 ? 'primary' : _props$appearance,
      dataE2e = props.dataE2e,
      actions = props.actions,
      small = props.small,
      fullWidth = props.fullWidth,
      disabled = props.disabled,
      otherProps = __rest(props, ["children", "iconName", "iconColor", "type", "appearance", "dataE2e", "actions", "small", "fullWidth", "disabled"]);

  var mainDataE2ELabel = getE2eLabel(children, E2E.MAIN, dataE2e);
  var actionDataE2ELabel = getE2eLabel(children, E2E.ACTION, dataE2e);
  var actionsButtonRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var togglePopover = function togglePopover() {
    return setIsExpanded(!isExpanded);
  };

  var closePopover = function closePopover() {
    return setIsExpanded(false);
  };

  var handlePopoverClick = function handlePopoverClick() {
    closePopover();
    if (actionsButtonRef.current) actionsButtonRef.current.focus();
  };

  return React.createElement(ButtonWrapper, {
    fullWidth: fullWidth
  }, React.createElement(MainButton, Object.assign({
    appearance: appearance,
    hasIcon: !!iconName,
    type: type,
    dataE2e: mainDataE2ELabel,
    hasActions: !!(actions === null || actions === void 0 ? void 0 : actions.items),
    small: small,
    fullWidth: fullWidth,
    disabled: disabled
  }, otherProps), !!iconName && React.createElement(ButtonIcon, {
    name: iconName,
    iconColor: iconColor,
    small: small,
    disabled: disabled
  }), React.createElement(ButtonTitle, null, children)), (actions === null || actions === void 0 ? void 0 : actions.items) && React.createElement(ActionsWrapper, {
    onClickOutside: closePopover
  }, React.createElement(ActionsButton, {
    onClick: togglePopover,
    appearance: appearance,
    type: type,
    ref: actionsButtonRef,
    disabled: disabled,
    dataE2e: actionDataE2ELabel
  }, React.createElement(ArrowIcon, {
    isOpen: isExpanded
  })), React.createElement(Popover, {
    open: isExpanded,
    onClose: closePopover,
    onClick: actions.closeOnClick ? handlePopoverClick : undefined,
    position: 'bottom left',
    offset: "0 0 12px 0",
    triangleOffset: 6,
    autoFocus: actions.autoFocus,
    width: actions.width,
    withShadow: true
  }, actions.items)));
};